/**
 * Module-level reference to the currently-active SceneClient.
 *
 * Stage H needs the pen tool and the canvas's pointer-move handler to
 * broadcast cursors and stroke-live batches, but both live outside the
 * React tree that owns the client instance. Rather than prop-drill an
 * optional callback down through the tool registry, we keep a tiny
 * mutable holder that the Vtt page sets when it starts the client and
 * clears on cleanup. Broadcasters call `.instance?.sendCursor(...)` and
 * silently no-op when offline (dev mode, reconnecting, etc.).
 */
import type { SceneClient } from "./SceneClient";

export const currentSceneClient: { instance: SceneClient | null } = {
  instance: null,
};
